import { render, staticRenderFns } from "./ApplicationDetailPage.vue?vue&type=template&id=224ed7f7&"
import script from "./ApplicationDetailPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ApplicationDetailPage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ApplicationDetailPage.vue?vue&type=style&index=0&id=224ed7f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports